/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAuth0Connection } from './ControlAuth0Connection';
import {
    ControlAuth0ConnectionFromJSON,
    ControlAuth0ConnectionFromJSONTyped,
    ControlAuth0ConnectionToJSON,
} from './ControlAuth0Connection';

/**
 * 
 * @export
 * @interface ControlSSOLoginRequest
 */
export interface ControlSSOLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    code: string;
    /**
     * 
     * @type {ControlAuth0Connection}
     * @memberof ControlSSOLoginRequest
     */
    connection: ControlAuth0Connection;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    jwt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    deeplink?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    u?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSSOLoginRequest
     */
    origin?: string;
}

/**
 * Check if a given object implements the ControlSSOLoginRequest interface.
 */
export function instanceOfControlSSOLoginRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "connection" in value;

    return isInstance;
}

export function ControlSSOLoginRequestFromJSON(json: any): ControlSSOLoginRequest {
    return ControlSSOLoginRequestFromJSONTyped(json, false);
}

export function ControlSSOLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSSOLoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'connection': ControlAuth0ConnectionFromJSON(json['connection']),
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
        'deeplink': !exists(json, 'deeplink') ? undefined : json['deeplink'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'u': !exists(json, 'u') ? undefined : json['u'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
    };
}

export function ControlSSOLoginRequestToJSON(value?: ControlSSOLoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'connection': ControlAuth0ConnectionToJSON(value.connection),
        'jwt': value.jwt,
        'deeplink': value.deeplink,
        'email': value.email,
        'u': value.u,
        'origin': value.origin,
    };
}

